module.exports = __webpack_public_path__ + "static/media/project_approval.342c5b50.svg";